import { render, staticRenderFns } from "./delete-csv.vue?vue&type=template&id=8057271e&scoped=true&"
import script from "./delete-csv.vue?vue&type=script&lang=js&"
export * from "./delete-csv.vue?vue&type=script&lang=js&"
import style0 from "./delete-csv.vue?vue&type=style&index=0&id=8057271e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8057271e",
  null
  
)

export default component.exports